import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Button,
  DialogFooter,
} from "@pushpress/pushpress-ui";
import { AlertTriangle } from "lucide-react";

type ConnectStripeInfoModalProps = {
  closeModal: () => void;
  isOpen: boolean;
};

export default function ConnectStripeInfoModal({
  isOpen,
  closeModal,
}: ConnectStripeInfoModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={() => closeModal()} modal>
      <DialogContent
        variant="noPadding"
        className="sm:max-w-[425px]"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader className="tw-pt-4 tw-pb-5 tw-border-b">
          <DialogTitle className="tw-text-neutral-800 tw-text-center !tw-font-medium tw-text-xl">
            Unable to add payment method
          </DialogTitle>
        </DialogHeader>
        <div className="tw-text-center tw-px-4">
          <AlertTriangle className="tw-h-10 tw-w-10 tw-text-error tw-mx-auto tw-mb-2.5" />
          <p className="tw-text-sm tw-text-neutral-600 tw-font-medium">
            Please connect Stripe before adding a payment method.
          </p>
        </div>
        <DialogFooter className="tw-flex !tw-justify-between tw-border-t tw-py-6 tw-px-6 tw-mt-auto">
          <Button variant="outline" size="default" onClick={() => closeModal()}>
            Cancel
          </Button>
          <Button
            onClick={() =>
              window.open("/settings/bank", "_blank", "noopener,noreferrer")
            }
          >
            Connect Stripe
          </Button>{" "}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
